import React, { useState, useEffect } from "react"; 
import { OutlinedButton, TextInputDropdown, TextInput } from '../../../../components';
import { MenuItem } from "@mui/material";
import { useStore } from '../../../../stores';
import '../style.scss';

const CreateBrief = ({ onClose, clients, leads, isCreated, briefs }) => {
    const { briefStore, uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [PageNumber, setPageNumber] = useState(1);
    const [Leads, setLeads] = useState([]);
    const [Clients, setClients] = useState([]);
    const [Brief, setBrief] = useState({
        category: '',
        client: '',
        date: new Date(),
        contract: {
            duration: "",
            signed: "",
            type: "",
            experience_level: ''
        },
        evaluation: {},
        finance: {
            invoices: [],
            amount: '',
            credippleFee: '',
            serviceFee: '',
            paymentMilestone: ''
        },
        fulfillmentLead: '',
        offering: '',
        professionals: [],
        projectPlan: {
            fulfillmentStage: "Brief",
            projectDuration: "",
            projStartDate: new Date(),
            projEndDate: new Date(),
            deliverables: [],
            startDate: new Date(),
            industryCategory: '',
            location: '',
            driveLink: ''
        },
        referenceNumber: '',
        status: 'Not Started',
        title: '',
    });
    const [Briefs, setBriefs] = useState([]);

    useEffect(() => {
        setClients(clients);
        setLeads(leads);
        setBriefs(briefs);
    }, [clients, leads, briefs]);

    const handleNextClick = () => {
        if (PageNumber < 3) setPageNumber(PageNumber + 1);
    };
    const handleBackClick = () => {
        if (PageNumber > 1) setPageNumber(PageNumber - 1);
    };

    const handleOnSubmit = async () => {
        uiStore.setLoading(true);
        try {
            let newBrief = { ...Brief };
            let duration = calculateDateDifference(newBrief.projectStartDate, newBrief.projectPlan.projEndDate);
            newBrief.projectPlan.projectDuration = duration;

            const client = Clients.find(item => item._id === newBrief.client);
            if (!client) {
                uiStore.showNotification({ type: 'error', message: 'Client not found' });
                return;
            }

            const modifiedData = {
                briefStatus: newBrief.status,
                briefTitle: newBrief.title,
                briefDescription: "No Data",
                deliverables: 'No Data',
                budgetEstimation: newBrief.finance.amount,
                client: newBrief.client,
                contractType: newBrief.contract.type,
                duration: newBrief.projectPlan.projectDuration,
                email: client.email,
                finance: newBrief.finance,
                firstName: client.firstName,
                hasDeadline: '0',
                industry: newBrief.projectPlan.industryCategory,
                location: newBrief.projectPlan.location,
                professionalExperienceLevel: newBrief.contract.experience_level,
                projectEndDate: newBrief.projectPlan.projectEndDate,
                projectPlan: [newBrief.projectPlan],
                professionals: [],
                projectStartDate: newBrief.projectPlan.projectEndDate,
                referenceNumber: newBrief.referenceNumber,
                serviceCategory: newBrief.category,
                servicesOffered: newBrief.offering,
                talentPartner: newBrief.fulfillmentLead,
                offering: newBrief.offering,
                workingEnvironment: "No Data",
            };

            const brief = await briefStore.createBrief(modifiedData);
            if (!brief) {
                uiStore.showNotification({ type: 'error', message: 'Failed to create brief!' });
                return;
            }

            uiStore.showNotification({ type: 'success', message: 'Brief created successfully!' });
            isCreated(true);
            onClose(false);
        } catch (error) {
            uiStore.showNotification({ type: 'error', message: 'Something went wrong!' });
        } finally {
            uiStore.setLoading(false);
            forceUpdate();
        }
    };

    function calculateDateDifference(startDate, endDate) {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const differenceInTime = end.getTime() - start.getTime();
        const differenceInDays = Math.floor(differenceInTime / (1000 * 60 * 60 * 24));

        if (differenceInDays >= 30) {
            const months = Math.floor(differenceInDays / 30);
            return `${months} month${months > 1 ? 's' : ''}`;
        } else if (differenceInDays >= 7) {
            const weeks = Math.floor(differenceInDays / 7);
            return `${weeks} week${weeks > 1 ? 's' : ''}`;
        } else {
            return `${differenceInDays} day${differenceInDays > 1 ? 's' : ''}`;
        }
    }

    const handlePageTwoValues = (e, fieldId) => {
        let brief = { ...Brief };
        if (fieldId === 'Offering') brief.offering = e.target.value;
        else if (fieldId === 'Experience_Level') brief.contract.experience_level = e.target.value;
        else if (fieldId === 'Contract_Type') brief.contract.type = e.target.value;
        else if (fieldId === 'Category_of_Service') brief.category = e.target.value;
        setBrief(brief);
        forceUpdate();
    };

    const handlePageOneValues = (e) => {
        const id = e.currentTarget.id;
        let brief = { ...Brief };
        let briefsCopy = [...Briefs];

        if (id === 'ProjectName') brief.title = e.target.value;
        if (id === 'Start_Date') brief.projectPlan.projStartDate = e.target.value;
        if (id === 'End_Date') brief.projectPlan.projEndDate = e.target.value;
        if (id === 'Industry_Category') brief.projectPlan.industryCategory = e.target.value;
        if (id === 'Location') brief.projectPlan.location = e.target.value;

        brief.referenceNumber = `#BRIEF${(briefsCopy.length + 1).toString().padStart(6, '0')}`;
        setBrief(brief);
        forceUpdate();
    };

    const getBriefClient = (e) => {
        setBrief(prev => ({ ...prev, client: e.target.value }));
        forceUpdate();
    };

    const getBriefFulfillment = (e) => {
        setBrief(prev => ({ ...prev, fulfillmentLead: e.target.value }));
        forceUpdate();
    };

    const getPageThreeValues = (e) => {
        const id = e.currentTarget.id;
        let brief = { ...Brief };

        if (id === 'Total_Project_Costs') {
            brief.finance.amount = e.target.value;
            brief.finance.credippleFee = brief.finance.amount * 0.12;
            brief.finance.serviceFee = brief.finance.amount - brief.finance.credippleFee;
        }
        if (id === 'Invoice_Number') {
            brief.finance.invoices[0] = e.target.value;
        }
        setBrief(brief);
        forceUpdate();
    };

    return (
        <div className="blur_div">
            <div className="create_parent">
                <p className="create_title">Create Brief</p>
                {PageNumber === 1 ? (
                    <div className="create_parent_inner">
                        <TextInput style={{ width: '45%' }} label='Project Name' placeholder='Project Name' id='ProjectName' onChange={handlePageOneValues} value={Brief.title} />
                        <TextInput style={{ width: '45%' }} label='Start Date' type='date' id='Start_Date' onChange={handlePageOneValues} value={Brief.projectStartDate} />
                        <TextInput style={{ width: '45%' }} label='Job Number' placeholder='Job Number' id='Job_Number' value={Brief.referenceNumber} />
                        <TextInput style={{ width: '45%' }} label='End Date' type='date' id='End_Date' onChange={handlePageOneValues} value={Brief.projectPlan.projEndDate} />
                        <TextInput style={{ width: '45%' }} label='Industry Category' placeholder='Industry Category' id='Industry_Category' onChange={handlePageOneValues} value={Brief.projectPlan.industryCategory} />
                        <TextInput style={{ width: '45%' }} label='Location' placeholder='Location' id='Location' onChange={handlePageOneValues} value={Brief.projectPlan.location} />
                    </div>
                ) : PageNumber === 2 ? (
                    <div className="create_parent_inner">
                        <TextInputDropdown id='Offering' label='Offering' onChange={(e) => handlePageTwoValues(e, 'Offering')} style={{ width: '45%' }} value={Brief.offering}>
                            <MenuItem value='Talent Access: Retainer'>Talent Access: Retainer</MenuItem>
                            <MenuItem value='Talent Access: Once off'>Talent Access: Once off</MenuItem>
                            <MenuItem value='Talent Partner: Plcement'>Talent Partner: Placement</MenuItem>
                            <MenuItem value='Talent Partner: Team Assembly'>Talent Partner: Team Assembly</MenuItem>
                            <MenuItem value='Talent Partner: Voucher'>Talent Partner: Voucher</MenuItem>
                            <MenuItem value='RWS : Remote workplace simulation'>RWS : Remote workplace simulation</MenuItem>
                        </TextInputDropdown>
                        <TextInputDropdown style={{ width: '45%' }} id='Experience_Level' label='Experience Level' onChange={(e) => handlePageTwoValues(e, 'Experience_Level')} value={Brief.contract.experience_level}>
                            <MenuItem value='Entry Level'>Entry Level</MenuItem>
                            <MenuItem value='Junior'>Junior</MenuItem>
                            <MenuItem value='Junior-Intermediate'>Junior-Intermediate</MenuItem>
                            <MenuItem value='Intermediate'>Intermediate</MenuItem>
                            <MenuItem value='Intermediate-Senior'>Intermediate-Senior</MenuItem>
                            <MenuItem value='Senior'>Senior</MenuItem>
                        </TextInputDropdown>
                        <TextInputDropdown style={{ width: '45%' }} id='Contract_Type' label='Contract Type' onChange={(e) => handlePageTwoValues(e, 'Contract_Type')} value={Brief.contract.type}>
                            <MenuItem value='Once-Off'>Once-Off</MenuItem>
                            <MenuItem value='Short-Term Placement'>Short-Term Placement</MenuItem>
                            <MenuItem value='Fixed-Term Placement'>Fixed-Term Placement</MenuItem>
                            <MenuItem value='Permanent Placement'>Permanent Placement</MenuItem>
                            <MenuItem value='Ongoing'>Ongoing</MenuItem>
                        </TextInputDropdown>
                        <TextInputDropdown style={{ width: '45%' }} id='Category_of_Service' label='Category of Service' onChange={(e) => handlePageTwoValues(e, 'Category_of_Service')} value={Brief.category}>
                            <MenuItem value='Design & Illustration'>Design & Illustration</MenuItem>
                            <MenuItem value='Digital Marketing & Social Media'>Digital Marketing & Social Media</MenuItem>
                            <MenuItem value='Mobile & Web Development'>Mobile & Web Development</MenuItem>
                            <MenuItem value='Photography & Videography'>Photography & Videography</MenuItem>
                            <MenuItem value='Writing Services'>Writing Services</MenuItem>
                            <MenuItem value='Other Services'>Other Services</MenuItem>
                        </TextInputDropdown>
                        <TextInputDropdown style={{ width: '45%' }} id='Client' label='Client' onChange={getBriefClient}>
                            {Clients && Clients.length > 0 ? Clients.map((item, i) => {
                                item['fullName'] = item.firstName && item.lastName ? `${item.firstName} ${item.lastName}` : item.companyName || '';
                                return <MenuItem key={i} value={item._id}>{item.fullName}</MenuItem>;
                            }) : <MenuItem disabled></MenuItem>}
                        </TextInputDropdown>
                        <TextInputDropdown style={{ width: '45%' }} id='Fulfilment_Lead' label='Fulfillment Lead' onChange={getBriefFulfillment}>
                            {Leads && Leads.length > 0 ? Leads.map((item, i) => (
                                <MenuItem key={i} value={item._id}>{`${item.firstName} ${item.lastName}`}</MenuItem>
                            )) : <MenuItem disabled></MenuItem>}
                        </TextInputDropdown>
                    </div>
                ) : (
                    <div className="create_parent_inner">
                        <TextInput style={{ width: '45%' }} label="Total Project Costs" type='number' placeholder='ZAR' id='Total_Project_Costs' onChange={getPageThreeValues} value={Number(Brief.finance.amount) || ''} />
                        <TextInput style={{ width: '45%' }} label='Service Provider Fee' type='number' placeholder='ZAR' id='Service_Fee' onChange={getPageThreeValues} value={Brief.finance.serviceFee} />
                        <TextInput style={{ width: '45%' }} label='Credipple Fee' type='number' placeholder='ZAR' id='Credipple_Fee' value={Number(Brief.finance.credippleFee).toFixed(2)} />
                        <TextInput style={{ width: '45%' }} label='Invoice Number' placeholder='YCD67S8' id='Invoice_Number' value={Brief.finance.invoices} />
                    </div>
                )}
                <div className="foot_comps">
                    <div className="dot_div">
                        <p className={PageNumber === 1 ? "dot_selected" : 'dot'}></p>
                        <p className={PageNumber === 2 ? "dot_selected" : 'dot'}></p>
                        <p className={PageNumber === 3 ? "dot_selected" : 'dot'}></p>
                    </div>
                    <div className="buttons_">
                        <OutlinedButton style={{ width: '49%' }} className='btn_cancel' onClick={PageNumber === 1 ? onClose : handleBackClick}>
                            {PageNumber === 1 ? 'Cancel' : 'Back'}
                        </OutlinedButton>
                        <OutlinedButton style={{ width: '49%' }} className='btn_next' onClick={PageNumber !== 3 ? handleNextClick : handleOnSubmit}>
                            {PageNumber === 3 ? 'Save' : 'Next'}
                        </OutlinedButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateBrief;
